<form [formGroup]="eventForm" (ngSubmit)="onSubmit()">
  <app-loader *ngIf="courseLoading$ | async"></app-loader>
  <mat-dialog-content *ngIf="(courseLoading$ | async) === false">
    <mat-form-field *ngIf="!groupId" appearance="outline">
      <mat-label>Выберите курс</mat-label>
      <mat-select
        required
        [errorStateMatcher]="matcher"
        formControlName="course">
        <mat-option *ngFor="let course of courses$" [value]="course.id">
          {{ course.title }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="course!.errors?.required">
        {{ requiredErrorMessage }}
      </mat-error>
      <mat-error>{{ getMessageFormError('course') }}</mat-error>
    </mat-form-field>

    <mat-form-field *ngIf="!groupId" appearance="outline">
      <mat-label>Выберите группу</mat-label>
      <mat-select
        required
        [errorStateMatcher]="matcher"
        formControlName="group">
        <mat-option *ngFor="let group of groups$" [value]="group.id">
          {{ group.full_name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="group!.errors?.required">
        {{ requiredErrorMessage }}
      </mat-error>
      <mat-error>{{ getMessageFormError('group') }}</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Выберите тип</mat-label>
      <mat-select
        required
        [errorStateMatcher]="matcher"
        formControlName="type"
        (selectionChange)="changeTypeHandler($event)">
        <mat-option *ngFor="let type of types | keyvalue" [value]="type.key">
          {{ type.value }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="type!.errors?.required">
        {{ requiredErrorMessage }}
      </mat-error>
      <mat-error>{{ getMessageFormError('type') }}</mat-error>
    </mat-form-field>

    <mat-form-field
      *ngIf="isShowNameField()"
      appearance="outline"
      class="pb-4 pb-sm-2">
      <mat-label>Название</mat-label>
      <input
        required
        matInput
        [errorStateMatcher]="matcher"
        formControlName="name" />
      <mat-error *ngIf="name!.errors?.required">
        {{ requiredErrorMessage }}
      </mat-error>
      <mat-error>{{ getMessageFormError('name') }}</mat-error>
    </mat-form-field>

    <div class="mb-5">
      <mat-form-field appearance="outline" class="pb-4 pb-sm-2">
        <mat-label>Тема</mat-label>
        <input matInput formControlName="theme" />
        <mat-error *ngIf="theme!.errors?.required">
          {{ requiredErrorMessage }}
        </mat-error>
        <mat-error>{{ getMessageFormError('theme') }}</mat-error>
        <mat-hint>
          Давайте осмысленное название теме. Например: <br />
          Занятие №4 Позиционирование, z-index
        </mat-hint>
      </mat-form-field>
    </div>

    <div class="mb-4">
      <app-date-picker
        formControlName="date"
        label="Дата события"
        hint="ДД-ММ-ГГГГ"
        [formGroup]="eventForm"
        [appearance]="'outline'"
        [control]="date"
        [datePicker]="date"
        [errorFromApi]="errors$ && errors$.date ? errors$.date[0] : null"
        [requiredErrorMessage]="requiredErrorMessage"></app-date-picker>
    </div>

    <mat-form-field appearance="outline">
      <mat-label>Время события</mat-label>
      <input
        required
        type="time"
        matInput
        [errorStateMatcher]="matcher"
        formControlName="time" />
      <mat-error *ngIf="time!.errors?.required">
        {{ requiredErrorMessage }}
      </mat-error>
      <mat-error>{{ getMessageFormError('time') }}</mat-error>
    </mat-form-field>
  </mat-dialog-content>
  <div mat-dialog-actions class="justify-content-end">
    <button type="button" class="mr-2" mat-raised-button (click)="onCancel()">
      Отмена
    </button>
    <app-button-with-progress
      typeBtn="submit"
      [loading$]="sendLoading$ | async"
      label="Создать"></app-button-with-progress>
  </div>
</form>
